<template>
  <SelectComponent
    v-model="selectedValues"
    :values="category()"
    :label="$t('global.invoicing_category')"
    :required="required"
    name="invoicing_category"
    :errors="errors"
    :edition-mode="editionMode"
    :alphabetical-order="true"
  />
</template>

<script>
import { mapGetters } from 'vuex'
import { computed } from 'vue'
import SelectComponent from '@c/BaseFormComponent/SelectComponent'

export default {
  name: 'SelectInvoicingCategory',
  components: { SelectComponent },
  props: {
    editionMode: {
      type: Boolean,
      required: true
    },
    errors: {
      type: Array,
      required: false,
      default: () => []
    },
    modelValue: {
      type: [Array, Number],
      required: true
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const selectedValues = computed({
      get: () => props.modelValue,
      set: (value) => emit('update:modelValue', value)
    })
    return { selectedValues }
  },
  computed: {
    ...mapGetters({
      invoicingCategories: 'metadata/getMetadataInvoicingCategories'
    }),

  },
  methods : {
    category(){
      for(let i in this.invoicingCategories) {
        if(this.invoicingCategories[i]?.name[this.$i18n.locale]){
          this.invoicingCategories[i].name =  this.invoicingCategories[i]?.name[this.$i18n.locale]
        }else if(Object.keys(this.invoicingCategories[i]?.name).length === 1){
          this.invoicingCategories[i].name = this.invoicingCategories[i]?.name[Object.keys(this.invoicingCategories[i]?.name)]
        }
      }
      return this.invoicingCategories;
    }
  },
}
</script>
